import owd from 'owd/owd';
import anime from 'animejs';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock/lib/bodyScrollLock.es6';

const defaults = {
	duration: 1000,
	lockDuration: 600,
	internalLockDuration: 1000,
	sectionSelector: '.section',
	ease: 'easeOutQuint'
};

export default class FullpageContainer extends owd.Component {
	init() {
		this.animCtr = 0;
		this.curr = 0;
		this.isEnabled = false;
		this.internalLock = false;
		this.externalLock = false;
		this.sectionSelector = this.$element.data('fullpage-container');
		this.baseHref = location.href.split('#')[0];
		this.containerAdditionalClass = null;

		this.lastDragOffset = 0;
		this.animationInProgress = false;
		this.dragFixScroll = false;

		this.$nav = this.$element.find('[data-fullpage-nav]');

		const hashParts = location.hash.split('/');
		
		if (hashParts[1] === 'section' && !isNaN(hashParts[2]) && hashParts[2] != this.curr) {
			this.curr = parseInt(hashParts[2]);
		}

		this.options = $.extend(defaults, {});

		if (this.$element.data('fullpage-container-duration') !== undefined) {
			this.options.duration = this.$element.data('fullpage-container-duration');
		}

		if (this.$element.data('fullpage-container-ease') !== undefined) {
			this.options.ease = this.$element.data('fullpage-container-ease');
		}

		if (window.matchMedia('(max-width: 1024px)').matches) {
			this.options.duration = 600;
			this.options.ease = 'easeOutQuad';
		}
		
		if (!this.sectionSelector) {
			this.sectionSelector = this.options.sectionSelector;
		}

		this.createWrappers();
		
		this.$sections = this.$wrapperInner.find(this.sectionSelector);
		this.sectionsHeight = [];
		this.count = this.$sections.length;
		this.$currentSection = this.$sections.eq(this.curr);


		this.$sections.not(this.$currentSection).removeClass('is-current');
		this.$currentSection.addClass('is-current');

		this.responsive();
		this.buildNav();

		this.calculateDistance();
		this.bindCalculateDistance();
		this.bindResize();
		this.bindButtons();
		this.bindNav();
		this.updateNav();

		if (this.curr !== 0) {
			this.changeHash();
		}

		setTimeout(() => {
			this.reposition();
			this.sectionInPrepare(this.$currentSection, 0, this.options)
				.then(() => {
					this.sectionIn(this.$currentSection, 0, this.options);
				});
		});

		if (window.matchMedia('(max-width: 767px)').matches) {
			if (this.curr > 0) {
				let $s = this.$sections.eq(this.curr);

				if ($s.length) {
					let st = $s.offset().top;
					this.dom.$window.scrollTop(st);
				}
			}
		}
	}
	
	responsive() {
		if (window.matchMedia('(min-width: 768px)').matches) {
			if (!this.isEnabled) {
				this.dom.$window.scrollTop(0);
				this.wireToCore();
				this.$wrapperInner.css({
					willChange: 'transform'
				});
				this.reposition();

				this.isEnabled = true;

				disableBodyScroll(this.$element[0], {
					reserveScrollBarGap: true
				});
			}
		} else {
			if (this.isEnabled) {
				this.unwireFromCore();
				this.$wrapperInner.css({
					y: '',
					willChange: ''
				}).removeAttr('style');
				this.dom.$window.scrollTop(this.$currentSection.offset().top);

				this.isEnabled = false;

				enableBodyScroll(this.$element[0]);
			}
		}
	}

	buildNav() {
		if (this.$nav.length) {
			let $ul = $('<ul></ul>');

			this.$sections.each((index, item) => {
				let label = $(item).data('nav-title');
				let url = this.baseHref +  `#/section/${(index + 1)}`;

				if ($(item).data('slug') !== undefined) {
					url += '/' + $(item).data('slug');
				}

				$ul.append(`<li data-slide="${index}"><a href="${url}" class="no-ajax"><span class="label">${label}</span></a></li>`);
			});

			this.$nav.append($ul);
		}
	}

	updateNav() {
		if (this.$nav.length) {
			this.$nav.find('li.is-current').removeClass('is-current');
			this.$nav.find('li').eq(this.curr).addClass('is-current');
		}
	}

	wireToCore() {
		this.up = this.up.bind(this);
		this.down = this.down.bind(this);
		this.dragMove = this.dragMove.bind(this);
		this.dragRelease = this.dragRelease.bind(this);

		this.app.getModule('fullpage')
			.on('up', this.up)
			.on('down', this.down)
			.on('drag-move', this.dragMove)
			.on('drag-release', this.dragRelease)
			.addView(this);
	}

	unwireFromCore() {
		this.app.getModule('fullpage')
		.off('up', this.up)
		.off('down', this.down)
		.off('drag-move', this.dragMove)
		.off('drag-release', this.dragRelease)
		.removeView(this);
	}

	createWrappers() {
		this.$element.append('<div class="fp-wrapper-inner">');
		this.$wrapperInner = this.$element.children('.fp-wrapper-inner');
		this.$wrapperInner.append(this.$element.children(this.sectionSelector));
		this.$wrapperInner.css({
			y: 0,
			willChange: 'transform'
		});
		this.$wrapper = this.$element;
		this.$wrapper.removeClass('is-scrolled');
	}

	bindNav() {
		this.on('click', '[data-fullpage-nav] a', (e) => {
			e.preventDefault();

			if (this.isEnabled) {
				this.app.getModule('fullpage').enable();
				this.moveTo($(e.target).parent().data('slide'));
			}
		});
	}

	bindButtons() {
		this.on('click', '[data-fullpage-prev]', (e) => {
			if (this.isEnabled) {
				e.preventDefault();
				this.app.getModule('fullpage').enable();
				this.up();
			}
		});

		this.on('click', '[data-fullpage-next]', (e) => {
			if (this.isEnabled) {
				e.preventDefault();
				this.app.getModule('fullpage').enable();
				this.down();
			}
		});
		
		this.on('click', this.dom.$body, '[data-fullpage-goto]', (e) => {
			if (this.isEnabled) {
				e.preventDefault();
				this.app.getModule('fullpage').enable();
				this.moveTo($(e.currentTarget).data('fullpage-goto'));
			} else if (window.matchMedia('(max-width: 767px)').matches) {
				let $s = this.$sections.eq($(e.currentTarget).data('fullpage-goto'));

				if ($s.length) {
					let st = $s.offset().top;
					
					$('html,body').animate({
						scrollTop: st
					}, 800, 'easeOutQuad');
				}
			}
		});
	}

	bindCalculateDistance() {
		this.on(
			'load pageInEnd', 
			this.dom.$window, 
			this.calculateDistance.bind(this)
			);
	};

	bindResize() {
		this.on(
			'load resize fp-recalc', 
			this.dom.$window, 
			this.responsive.bind(this)
			);

		this.on(
			'load resize fp-recalc', 
			this.dom.$window, 
			this.reposition.bind(this)
			);
	}

	updateSections() {
		this.$sections = this.$wrapperInner.find(this.sectionSelector);
		this.calculateDistance();
		this.reposition();
	}

	reposition() {
		if (this.isEnabled) {
			this.sectionsHeight = [];

			this.$sections.each((index, section) => {
				this.sectionsHeight.push($(section).outerHeight());
			});

			this.$wrapperInner.stop().css({
				y: this.offsetFor(this.curr) * -1
			});
		}
	}

	offsetFor(page) {
		let i, sum = 0;

		for (i = 0; i <= page; i++) {
			sum += this.sectionsHeight[i];
		}

		sum -= this.dom.$window.height();

		return sum;
	}

	speedFor(page, speed) {
		return speed; //Math.min(speed, this.vars.sectionsHeight[page] / $(window).height() * speed);
	};

	calculateDistance() {
		this.internalLock = false;

		this.sectionsHeight = [];
		this.$sections.each((index, section) => {
			this.sectionsHeight.push($(section).outerHeight());
		});

		setTimeout(() => {
			this.vh = this.dom.$window.height();
			this.sh = this.$wrapperInner.outerHeight();

			this.count = this.calculateCount();
			this.dist = this.calculateDist();

			this.checkActiveSection();
		});
	}

	calculateCount() {
		return this.$sections.length;
	}

	calculateDist() {
		return this.vh;
	}

	disable() {
		this.externalLock = true;
	}

	enable() {
		this.externalLock = false;
	}

	dragMove(offset) {
		if (!this.internalLock && !this.animationInProgress) {
			
			if (this.curr < 1 && offset > 0) {
				offset = 0;
			} else if (this.curr + 1 >= this.count && offset < 0) {
				offset = 0;
			}

			this.$wrapperInner.css({
				y: this.offsetFor(this.curr) * -1 + offset
			});

			this.lastDragOffset = offset;

			if (!this.dragFixScroll) {
				if (this.curr > 0 && this.$sections.eq(this.curr - 1).is('.scrollable')) {
					this.$sections.eq(this.curr - 1).scrollTop(this.$sections.eq(this.curr - 1)[0].scrollHeight);
				}

				this.dragFixScroll = true;
			}

		}
	}

	dragRelease() {
		if (this.lastDragOffset && !this.animationInProgress) {
			anime({
				targets: this.$wrapperInner[0],
				translateY: [this.offsetFor(this.curr) * -1 + this.lastDragOffset, this.offsetFor(this.curr) * -1],
				duration: Math.min(250, Math.abs(this.lastDragOffset) * Math.abs(this.lastDragOffset) / 10),
				easing: 'easeOutQuad'
			});

			this.lastDragOffset = 0;
		}

		this.dragFixScroll = false;
	}

	up() {
		if (this.isEnabled) {
			if (!this.internalLock && this.curr - 1 >= 0) {
				this.moveTo(this.curr - 1);
			}
		}
	}

	down() {
		if (this.isEnabled) {
			if (!this.internalLock && this.curr + 1 < this.count) {
				this.moveTo(this.curr + 1);
			}
		}
	}

	moveTo(page, noAnimation, force) {
		return new Promise((resolve, reject) => {

			if (this.isEnabled) {
				if ((!this.internalLock && !this.externalLock && page != this.curr) || force === true) {
					this.lock();

					const prev = this.curr;
					const prevSection = this.$currentSection;
					const direction = prev > page ? -1 : 1;

					this.curr = page;
					this.animationInProgress = true;
					this.dragFixScroll = false;
	
					if (this.curr === 0) {
						this.$wrapper.removeClass('scrolled');
					} else {
						this.$wrapper.addClass('scrolled');
					}

					this.checkActiveSection();
					this.changeHash();

					const options = $.extend({
						noAnimation: noAnimation,
						duration: noAnimation === true ? 0 : this.speedFor(page, this.options.duration)
					}, this.options);

					this.$element.trigger('fp-move-to', {
						page : page, 
						direction : direction,
						sectionFrom: prevSection,
						sectionTo: this.$currentSection,
						options: options
					});

					let ctr = ++this.animCtr;

					this.sectionOut(prevSection, direction, options).then(() => {
						return this.sectionInPrepare(this.$currentSection, direction, options);
					}).then(() => {
						return new Promise((resolve, reject) => {
							anime({
								targets: this.$wrapperInner[0],
								translateY: [this.offsetFor(prev) * -1 + this.lastDragOffset, this.offsetFor(page) * -1],
								duration: options.duration,
								easing: options.ease
							}).finished.then(() => {
								setTimeout(() => {
									this.animationInProgress = false;
								}, 25);
								resolve();
							});
						});
					}).then(() => {
						this.checkActiveSection();
						this.dom.$window.trigger('fp-scroll');
						
						if (ctr === this.animCtr) {
							return this.sectionIn(this.$currentSection, direction, options);
						} else {
							return true;
						}
					}).then(() => {
						return this.sectionOutReset(prevSection, direction, options);
					}).then(() => {
						this.checkActiveSection();
						this.dom.$window.trigger('fp-scroll');
						resolve();
					});

				} else if (page == this.curr) {
					resolve();
				} else {
					reject();
				}
			}
		});
	}

	sectionIn($section, direction, options) {
		let sectionApi = $section.data('fullpageSectionApi');

		if (sectionApi) {
			return sectionApi.in(direction, options);
		}

		return new Promise(resolve => resolve());
	}
	
	sectionInPrepare($section, direction, options) {
		let sectionApi = $section.data('fullpageSectionApi');

		if (sectionApi) {
			return sectionApi.between(direction, options);
		}

		return new Promise(resolve => resolve());
	}

	sectionOut($section, direction, options) {
		let sectionApi = $section.data('fullpageSectionApi');

		if (sectionApi) {
			return sectionApi.out(direction, options);
		}

		return new Promise(resolve => resolve());
	}

	sectionOutReset($section, direction, options) {
		let sectionApi = $section.data('fullpageSectionApi');

		if (sectionApi) {
			return sectionApi.reset(direction, options);
		}

		return new Promise(resolve => resolve());
	}

	lock() {
		this.internalLock = true;

		setTimeout(() => {
			this.internalLock = false;
		}, Math.max(this.options.duration, this.options.internalLockDuration));
	}

	changeHash() {
		let newHash = '#/section/' + this.curr;

		if (this.$currentSection.data('slug') !== undefined) {
			newHash += '/' + this.$currentSection.data('slug');
		}

		if (window.history !== undefined) {
			history.replaceState({ internal: true }, undefined, newHash);
		}
	}

	checkActiveSection() {
		this.$currentSection = this.calculateCurrentSection();

		let sectionTheme;
		let overallTheme;

		if (this.$currentSection.length) {
			$(this.$currentSection[0].classList).each((i, val) => {
				if (val.indexOf('theme--') === 0) {
					sectionTheme = val;
				}
			});
		}

		if (this.containerAdditionalClass) {
			this.$element.removeClass(this.containerAdditionalClass);
		}

		this.containerAdditionalClass = this.$currentSection.data('fullpage-container-class');

		if (this.containerAdditionalClass) {
			this.$element.addClass(this.containerAdditionalClass);
		}

		this.$sections.not(this.$currentSection).removeClass('is-current');
		this.$currentSection.addClass('is-current');

		if ($('.overall').length && sectionTheme !== undefined) {
			$($('.overall')[0].classList).each((i, val) => {
				if (val.indexOf('theme--') === 0) {
					overallTheme = val;
				}
			});

			$('.overall').removeClass(overallTheme);
			$('.overall').addClass(sectionTheme);
		}

		this.updateNav();
	}

	calculateCurrentSection() {
		return this.calculateSectionAt(this.curr);
	}

	calculateSectionAt(index) {
		return this.$sections.eq(index);
	}

    destroy() {
		super.destroy();
		
		if (this.isEnabled) {
			this.unwireFromCore();
			enableBodyScroll(this.$element[0]);
		}
	}
}

owd.registerComponent('fullpage-container', {
	component: FullpageContainer
});